import { render, staticRenderFns } from "./TableLoader.vue?vue&type=template&id=0b29b9bc&scoped=true&"
import script from "./TableLoader.vue?vue&type=script&lang=js&"
export * from "./TableLoader.vue?vue&type=script&lang=js&"
import style0 from "./TableLoader.vue?vue&type=style&index=0&id=0b29b9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b29b9bc",
  null
  
)

export default component.exports